/**
 * Application Constants Configuration
 * Centralized place for application-wide constants that may need to be changed
 *
 * ENVIRONMENT VARIABLES (configured in .env file):
 * - REACT_APP_DEFAULT_ORGANIZATION_NAME: Default organization name for public/unauthenticated pages
 *   Used when organization context cannot be determined (guests, login page, etc.)
 *
 *   Pages using this constant: Login, ForgotPassword, ResetPassword, VerifyEmail,
 *   ReactivateAccount, KickedOutPage, PasswordResetRequired
 *   Mirrors backend EmailConfig.DEFAULT_ORGANIZATION_NAME for consistency
 *
 * - REACT_APP_APP_NAME: Application name displayed throughout the interface
 *
 * To customize these values:
 * - Update REACT_APP_DEFAULT_ORGANIZATION_NAME in .env or .env.local file
 * - Update REACT_APP_APP_NAME in .env or .env.local file
 * - Changes take effect on application restart
 */

// Default organization name used on public/unauthenticated pages
// Loaded from REACT_APP_DEFAULT_ORGANIZATION_NAME environment variable
// Mirrors backend EmailConfig.DEFAULT_ORGANIZATION_NAME for consistency
export const DEFAULT_ORGANIZATION_NAME =
  process.env.REACT_APP_DEFAULT_ORGANIZATION_NAME || 'Demo Healthcare Institute';

// Application metadata
// Loaded from REACT_APP_APP_NAME environment variable
export const APP_NAME =
  process.env.REACT_APP_APP_NAME || 'DevicePulse';

// Application metadata
// Loaded from REACT_APP_PARENT_COMPANY environment variable
export const PARENT_COMPANY_NAME =
  process.env.REACT_APP_PARENT_COMPANY || 'Tandem Healthcare';

// Session configuration
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
export const SESSION_WARNING_MS = 5 * 60 * 1000;  // Show warning 5 minutes before timeout

// Password requirements
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_STRENGTH_LEVELS = {
  'Very Weak': 0,
  'Weak': 1,
  'Fair': 2,
  'Good': 3,
  'Strong': 4,
  'Very Strong': 5
};
